var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import styles from '../../@patternfly/patternfly-next/layouts/Page/page.css.js';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';

export var PageSectionVariants = {
  default: 'default',
  light: 'light',
  dark: 'dark',
  darker: 'darker'
};

var propTypes = {
  /** Content rendered inside the section */
  children: PropTypes.node,
  /** Additional classes added to the section */
  className: PropTypes.string,
  /** Section background color variant */
  variant: PropTypes.oneOf(Object.values(PageSectionVariants))
};

var defaultProps = {
  children: null,
  className: '',
  variant: 'default'
};

var PageSection = function PageSection(_ref) {
  var _variantStyle;

  var className = _ref.className,
      children = _ref.children,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ['className', 'children', 'variant']);

  var variantStyle = (_variantStyle = {}, _defineProperty(_variantStyle, PageSectionVariants.default, ''), _defineProperty(_variantStyle, PageSectionVariants.light, styles.modifiers.light), _defineProperty(_variantStyle, PageSectionVariants.dark, styles.modifiers.dark_200), _defineProperty(_variantStyle, PageSectionVariants.darker, styles.modifiers.dark_100), _variantStyle);

  return React.createElement(
    'section',
    _extends({}, props, { className: css(styles.pageMainSection, variantStyle[variant], className) }),
    children
  );
};

PageSection.propTypes = propTypes;
PageSection.defaultProps = defaultProps;

export default PageSection;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/layouts/Page/PageSection.js
// module id = 302
// module chunks = 0